export default "\n>> **You will require admin access for successful integration.**";